import { AxiosError } from 'axios';
import webcoreService from 'helpers/services/webcoreService';
import { MegaMenuItem } from 'helpers/services/webcoreService/webcoreService';
import { useEffect, useState } from 'react';

/**
 * Custom hook function to retrieve data from mega menu
 */
export default function useMegaMenu(
  fetchFromApi = true
): {
  isLoading: boolean;
  items: MegaMenuItem[] | undefined;
  error: AxiosError | undefined;
} {
  const [items, setItems] = useState<MegaMenuItem[]>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<AxiosError>();

  useEffect(() => {
    const fetchItems = async () => {
      setIsLoading(true);

      try {
        const data = await webcoreService.getMegaMenuItems();
        setItems(data);
      } catch (e) {
        console.error(e);
        setError(e);
      }

      setIsLoading(false);
    };

    if (fetchFromApi) {
      fetchItems();
    }
  }, [fetchFromApi]);

  return { items, isLoading, error };
}
